export default {
  slideIn: {
    yPercent: -100
  },

  slideOut: {
    yPercent: -210,
    clearProps: true
  }
};
